import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["shareIcon", "checkIcon", "saveDialog"];

  connect() {
    this.copyTimeout = null;
  }

  disconnect() {
    if (this.copyTimeout) clearTimeout(this.copyTimeout);
  }

  // Copies *this page's own* URL (not the SPA's) — this is the page actually being
  // looked at, and it has its own permanent, crawlable address, unlike the plain
  // "Save" action below which genuinely has nothing to do without an account.
  // Swaps to a checkmark for a moment on success — the same icon-swap
  // MaterialModal.tsx's own Share button does (`shareCopied ? <CheckIcon/> :
  // <ShareIcon/>`), not a text-label change (this button carries no label at all,
  // matching that same icon-only button exactly).
  async copyShareLink() {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      // Clipboard API can refuse (insecure context, permissions) — fall back to a
      // manual-select prompt is overkill for what's already a nice-to-have;
      // silently no-op rather than throwing.
      return;
    }

    this.shareIconTarget.classList.add("hidden");
    this.checkIconTarget.classList.remove("hidden");
    if (this.copyTimeout) clearTimeout(this.copyTimeout);
    this.copyTimeout = setTimeout(() => {
      this.checkIconTarget.classList.add("hidden");
      this.shareIconTarget.classList.remove("hidden");
    }, 1800);
  }

  // This static page holds no account to save *into* — rather than a "Save" button
  // that silently does nothing (or worse, pretends to), this explains why and
  // hands off to the real app, where the material's own popup (with a real Save
  // button) is one click away.
  openSaveDialog() {
    this.saveDialogTarget.showModal();
  }

  closeSaveDialog() {
    this.saveDialogTarget.close();
  }
}
